import PropTypes from "prop-types";
import { makeStyles } from "tss-react/mui";
import { Link } from "react-router-dom";
import Stack from "@mui/material/Stack";
import { OverviewCardContainer } from "./card-container";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SvgIcon from "@mui/material/SvgIcon";
import Avatar from "@mui/material/Avatar";

const useStyles = makeStyles()((theme) => ({
  inputLabel: {
    color: "#fff",
    fontSize: "0.775rem",
    fontWeight: "Bold",
    display: "inline-flex",
    marginRight: "20px",
  },
  listItem: {
    display: "inline-flex",
    color: "#fff",
    textTransform: "uppercase",
    wordBreak: "break-word",
    "& .MuiTypography-root": {
      fontSize: "0.775rem",
    },
    "&.MuiListItemButton-root": {
      padding: "0px !important",
      textTransform: "none",
    },
    "&.MuiListItemButton-root:hover": {
      textDecoration: "underline",
      color: "#fff",
      backgroundColor: "transparent",
    },
  },
  box: {
    display: "block",
    margin: "0 !important",
  },
  TileLogo: {
    width: "100px",
    height: "24px",
    marginRight: "5px",
  },
  flex: {
    marginTop: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

export const DetailCard = (props) => {
  const { connections = [], items, sx, color, renderIcon } = props;
  const { classes } = useStyles();

  return (
    <OverviewCardContainer sx={sx} color={color}>
      <Stack alignItems="flex-start" direction="row" justifyContent="space-between" spacing={3}>
        <Stack alignItems="start" direction="column" spacing={2}>
          {items.map((item) => (
            <Stack className={classes.box} key={item.key} alignItems="center" direction="row" spacing={0}>
              <InputLabel className={classes.inputLabel}>{item.key}: </InputLabel>
              <ListItemText className={classes.listItem} primary={item.value} />
            </Stack>
          ))}
        </Stack>
        <Avatar
          sx={{
            height: 56,
            width: 56,
            background: "transparent",
            border: "2px solid",
          }}
        >
          <SvgIcon>{renderIcon()}</SvgIcon>
        </Avatar>
      </Stack>

      {!!connections.length && (
        <Box className={classes.flex}>
          {connections.map((connection) => (
            <Box key={connection.Type}>
              <img className={classes.TileLogo} src={connection.imgSrc} alt={connection.Type} />
              <Link to={connection.accessUrl} target="_blank">
                <IconButton size="small" color="info">
                  <OpenInNewIcon />
                </IconButton>
              </Link>
            </Box>
          ))}
        </Box>
      )}
    </OverviewCardContainer>
  );
};

DetailCard.propTypes = {
  sx: PropTypes.object,
  items: PropTypes.array,
  connections: PropTypes.array,
  color: PropTypes.string,
  renderIcon: PropTypes.func,
};
